import {
  Button,
  ChevronDownSVG,
  ChevronUpSVG,
  Chip,
  ChipGroup,
  Icon,
} from "@newsela/angelou";

import { withTrackEvent } from "@newsela/snitch";
import { useStandardsSearchContext } from "@/search/NewSearchPageMVP/provider/StandardsSearchProvider";
import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";
import { eventProperties } from "./FilterControls.constants";
import {
  clearButtonCss,
  expandCollapseButtonCss,
  expandCollapseContainerCss,
  expandCollapseCss,
  expandCollapseIconCss,
  filterControlsContainerCss,
  headerText,
  headingCss,
  selectedFilterCss,
  selectedFiltersChipGroupCss,
} from "./FilterControls.styles";
import { getFilterChipText } from "./FilterControls.utils";
import { useFilterControls } from "./hooks";

const ButtonWithTrackEvent = withTrackEvent(Button);

export const FilterControls = () => {
  const {
    allowCollapseFilters,
    filteredChipsToDisplay,
    showAllSelectedFilters,
    handleClearAllFilters,
    handleRemoveFilter,
    handleToggleShowFilters,
  } = useFilterControls();

  const {
    getters: { readingSkills = [] },
  } = useSearchPageContext();
  const { selectedStandards } = useStandardsSearchContext();

  if (filteredChipsToDisplay.length === 0) return null;

  return (
    <div css={filterControlsContainerCss}>
      <div css={headingCss}>
        <h2 css={headerText}>Selected filters</h2>
        <>
          <ButtonWithTrackEvent
            __cssFor={clearButtonCss}
            flavor={Button.flavors.tertiary}
            onClick={handleClearAllFilters}
            size={Button.sizes.sm}
            {...eventProperties("clear")}
            dataProps={{ "data-qa-selector": "search-clear-all-filters" }}
          >
            Clear filters
          </ButtonWithTrackEvent>
        </>
      </div>

      <ChipGroup
        size="sm"
        groupName="selectedFilters"
        onChipEvent={handleRemoveFilter}
        __cssFor={selectedFiltersChipGroupCss}
        chipType={ChipGroup.chipTypes.input}
      >
        {filteredChipsToDisplay.map(([paramName, paramValue], index) => {
          const filterLabelValue = getFilterChipText(
            paramName,
            paramValue,
            readingSkills,
            selectedStandards,
          );
          return (
            <Chip
              key={index}
              text={filterLabelValue}
              value={`${paramName},${paramValue}`}
              __cssFor={selectedFilterCss(
                filterLabelValue === "true" || filterLabelValue === "",
              )}
              dataProps={{
                "data-qa-selector": `search-${filterLabelValue}-chip`,
              }}
            />
          );
        })}
      </ChipGroup>

      {allowCollapseFilters && (
        <div css={expandCollapseContainerCss}>
          <ButtonWithTrackEvent
            size={Button.sizes.sm}
            __cssFor={expandCollapseButtonCss}
            flavor={Button.flavors.tertiary}
            onClick={handleToggleShowFilters}
            {...eventProperties(showAllSelectedFilters ? "collapse" : "show")}
            dataProps={{
              "data-qa-selector": `search-${showAllSelectedFilters ? "collapse" : "show"}-filter-chips`,
            }}
          >
            <span css={expandCollapseCss}>
              {showAllSelectedFilters ? "Collapse" : "View all"} filters
              <Icon
                __cssFor={{ root: expandCollapseIconCss }}
                title="Expand filters/Collapse filters"
                SvgComponent={
                  showAllSelectedFilters ? ChevronUpSVG : ChevronDownSVG
                }
              />
            </span>
          </ButtonWithTrackEvent>
        </div>
      )}
    </div>
  );
};
